import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Watergate Gallery</p>
        <h1>Discover Contemporary Art</h1>
        <p className="lede">
          Explore a curated selection of contemporary artworks from both established and emerging artists. 
          Experience the vibrant world of art and find pieces that resonate with you.
        </p>
        <div className="cta-row">
          <a href="/gallery" target="_blank">
            View Our Collection
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engage with Artists</h2>
          <p>
            Meet the creative minds behind the art. Join us for exclusive events and exhibitions that showcase 
            the talent of both established and emerging artists.
          </p>
        </article>
        <article>
          <h2>Find Your Inspiration</h2>
          <p>
            Whether you're a seasoned collector or a first-time buyer, our diverse collection offers something 
            for everyone. Discover pieces that inspire and elevate your space.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Become a part of our vibrant art community. Sign up for our newsletter to stay updated on new 
            arrivals, events, and special offers.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;